import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import TableView from '../../Components/TableView';

const AuthorTable = ({ data }) => {
  const columns = [
    {
      title: 'User Name',
      dataIndex: 'user_id__name',
      key: 'user_id__name',
      render: (value) => value || '-',
      align: 'center',
    },
    {
      title: 'Number of digests',
      dataIndex: 'count',
      key: 'count',
      render: (value) => value || '-',
      align: 'center',
    },
  ];
  return (
    <>
      <TableView tableColumns={columns} data={data} />
    </>
  );
};

AuthorTable.propTypes = {
  data: PropTypes.object,
};

export default AuthorTable;
